@if (source) {
<nav class="channels-nav">
  <bau365-channel-list-item
    [text]="forMeChannel"
    [active]="source.feed === 'ROOT'"
    (selectChannel)="onSelectForMe()"></bau365-channel-list-item>
  @if (sponsoredChannels && sponsoredChannels.length > 0) {
  <bau365-divider [text]="insightsNewsHeader"></bau365-divider>
  <bau365-channel-group [source]="source" [channels]="sponsoredChannels" (selectChannel)="onSelectChannel($event)">
  </bau365-channel-group>
  }
  <bau365-divider [text]="subscribedChannelsHeader"></bau365-divider>
  <bau365-channel-group
    [source]="source"
    [channels]="subscribedChannels"
    [addChannelsLink]="addChannelsLink"
    [addChannelsText]="addChannelsText"
    (selectChannel)="onSelectChannel($event)">
  </bau365-channel-group>
  @if (showHistoryChannel) {
  <bau365-divider [text]="myActivitiesHeader"></bau365-divider>
  <bau365-channel-list-item
    [text]="lastViewedChannel"
    [active]="source.feed === 'HISTORY'"
    (selectChannel)="onSelectLastViewed()"></bau365-channel-list-item>
  }
</nav>
}
